import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreRoutingModule } from './core-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LeadsComponent } from './Leads/Leads.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AssignedComponent } from './assigned/assigned.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { CreateLeadComponent } from './create-lead/create-lead.component';
import { MatStepperModule } from '@angular/material/stepper';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { MatIconModule } from '@angular/material/icon';
import { SalesManagerModalComponent } from './modals/sales-manager-modal/sales-manager-modal.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ChartComponentComponent } from './chart-component/chart-component.component';
import { SharedModule } from "../shared/shared.module";
import { LeadBulkUploadComponent } from './lead-bulk-upload/lead-bulk-upload.component';
import { FollowUpComponent } from './modals/follow-up/follow-up.component';
import { FollowUpListComponent } from './follow-up-list/follow-up-list.component';
import { LostJunkComponent } from './modals/lost-junk/lost-junk.component';
import { NonSalesComponent } from './modals/non-sales/non-sales.component';
import { NoResponseComponent } from './modals/no-response/no-response.component';
import { LostJunkListComponent } from './lost-junk-list/lost-junk-list.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MAT_DATE_LOCALE } from '@angular/material/core'
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { NotificationListDetailsComponent } from './notification-list-details/notification-list-details.component';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ChartModule } from 'primeng/chart';
import { MatTimepickerModule, provideNativeDateTimeAdapter } from "@dhutaryan/ngx-mat-timepicker";
import { SearchLeadComponent } from './search-lead/search-lead.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { UsersComponent } from './users/users.component';
import { UserGuideComponent } from './user-guide/user-guide.component';
import { NonSalesListComponent } from './non-sales-list/non-sales-list.component';
import { EmailSettingsComponent } from './email-settings/email-settings.component';

@NgModule({
    declarations: [
        LeadsComponent,
        AssignedComponent,
        CreateLeadComponent,
        UserProfileComponent,
        SalesManagerModalComponent,
        FollowUpComponent,
        ChartComponentComponent,
        LeadBulkUploadComponent,
        FollowUpListComponent,
        LostJunkComponent,
        NonSalesComponent,
        NoResponseComponent,
        LostJunkListComponent,
        ChangePasswordComponent,
        NotificationListDetailsComponent,
        PageNotFoundComponent,
        SearchLeadComponent,
        UsersComponent,
        UserGuideComponent,
        NonSalesListComponent,
        EmailSettingsComponent
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CoreRoutingModule,
        CommonModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatButtonModule,
        MatDialogModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatNativeDateModule,
        MatTabsModule,
        MatStepperModule,
        MatIconModule,
        NgApexchartsModule,
        SharedModule,
        MatSidenavModule,
        MatExpansionModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatListModule,
        MatButtonToggleModule,
        NgSelectComponent,
        BsDatepickerModule.forRoot(),
        NgxSkeletonLoaderModule.forRoot(),
        NgMultiSelectDropDownModule.forRoot(),
        ChartModule,
        MatTimepickerModule
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        provideNativeDateTimeAdapter()
    ]
})
export class CoreModule { }
